//@ts-nocheck
import { cart } from '../Cart/Cart';
import React, { Component } from 'react';
import '../../util/bsModal'; // enable bootstrap modal
import { Examentraining } from '../../models/Examentraining';
import { cartItemIsTraining } from '../../models/type.functions';

interface ComponentProps {
  noBooking: boolean;
  preregister: boolean;
  prijs: string;
  training: Examentraining;
}

interface ComponentState {
  status: ItemState;
}

export enum ItemState {
  BOOK = 'book',
  PROCESSING = 'processing',
  CART = 'cart',
}

export class SearchResultsBookBtn extends Component<ComponentProps, ComponentState> {

  constructor(props: ComponentProps) {
    super(props);

    const cartList = cart.get();

    let inCart: boolean = false;

    if (cartList) {
      const trainingIds = cartList
        .filter(item => cartItemIsTraining(item))
        .map((item: Examentraining) => item.id_training);

      inCart = trainingIds.includes(props.training.id_training);
    }
    this.state = {
      status: inCart ? ItemState.CART : ItemState.BOOK,
    };
  }

  /**
   * Perform action depending on the button state
   */
  public onClickButton(): void {
    const { status } = this.state;
    if (this.props.noBooking) {
      this.displayError();
    } else if (status === ItemState.BOOK) {
      this.addTraining();
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: 'EUR',
          items: [{
            item_id: `${this.props.training.id_training}`,
            item_name: `${this.props.training.vak_naam} / ${this.props.training.vak_niveau} ${this.props.training.product_naam}`,
            item_brand: 'Examentraining',
            item_category: this.props.training.vak_niveau,
            item_category2: this.props.training.loc_naam,
            item_category3: this.props.training.training_dates.replace(/,/g, ' / '),
            price: parseFloat(this.props.training.prijs),
            quantity: 1,
          }],
        },
      });
    } else if (status === ItemState.CART) {
      this.redirectTo();
    }
  }

  /**
   * Display the popup telling the customer to call the frontoffice
   */
  public displayError(): void {
    // @ts-ignore
    $('#bookingError').modal('show');
  }

  /**
   * Redirect the user to the cart
   */

  /* istanbul ignore next */
  public redirectTo(): void {
    window.location.href = '/winkelwagen/';
  }

  /**
   * Add the training to the localStorage and php session
   */
  public async addTraining(): Promise<void> {
    this.setState({ status: ItemState.PROCESSING });

    try {
      await cart.addTraining(this.props.training);
      this.enabledShoppingCart();

      // Update the WC counter visually
      if ( $('.cart-contents-count').length ){
        let cnt = +$('.cart-contents-count').html() + 1;
        $('.cart-contents-count').text(cnt );
      } else {
        $('a.cart-contents').append('<span class="cart-contents-count">1</span>');
      }

    } catch (e) {
      this.restoreItem();
    }

  }

  public enabledShoppingCart(): void {
    this.setState({ status: ItemState.CART });
  }

  public restoreItem(): void {
    this.displayError();
    this.setState({ status: ItemState.BOOK });
  }

  public render(): JSX.Element {
    const { status } = this.state;
    const { preregister } = this.props;
    const { prijs } = this.props;

    const koop = (<span className="search-results__item-table-button-icon">
      Nu boeken
    </span>);

    return (
      <button className="search-results__item-table-button"
        disabled={status === 'processing'}
        onClick={(): void => this.onClickButton()}>
        {status === ItemState.BOOK && (preregister ? 'Reserveren' : koop)}
        {status === ItemState.PROCESSING && 'Bezig...'}
        {status === ItemState.CART && 'Afronden'}
      </button>

    );
  }
}
